import styled, { css } from 'styled-components';
import theme from '../../styles/theme';

export const Content = styled.div`
  img {
    position: absolute;
    z-index: 99;
    top: 0;
    width: 100%;
    height: 128px;
    object-fit: cover;
  }
`;

export const InfoWrapper = styled.div`
  margin-top: 128px;
  padding: 32px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    font-size: 24px;
    font-weight: 500;
    line-height: 32px;
    color: ${theme.colors.colorGray500};
    padding-bottom: 16px;
  `}
`;

export const CloseButton = styled.button`
  position: relative;
  z-index: 98;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  width: 40px;
  height: 40px;
  margin-left: 20px;
  border: none;
  cursor: pointer;

  img {
    width: 40px;
    height: 40px;
  }
`;

export const Sector = styled.div`
  padding-top: 16px;
  padding-bottom: 12px;
  width: 100%;

  p#description {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    color: ${theme.colors.colorGray400};
    display: block;

    span {
      color: ${theme.colors.colorGray500};
    }
  }

  div {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    width: 100%;

    &#active {
      margin-bottom: 8px;
    }

    p {
      font-size: 16px;
      font-weight: 500;
      color: ${theme.colors.blueEinstein};
    }

    img {
      width: 24px;
      height: 24px;
      transform: rotate(0deg);
      transition: all 0.3s;
      cursor: pointer;
    }

    &#active img {
      transform: rotate(180deg);
      transition: all 0.3s;
    }
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e8e8e8;
  }
`;

export const TagList = styled.ul`
  margin-top: 16px;

  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  li {
    list-style: none;
    padding: 8px 16px;
    background-color: #ebf1f6;
    border-radius: 16px;

    font-size: 16px;
    font-weight: 500;
    color: ${theme.colors.blueEinstein};
  }
`;

export const Topic = styled.div`
  ${() => css`
    padding-top: 16px;
    padding-bottom: 16px;

    display: flex;
    flex-direction: row;

    &:not(:last-child) {
      border-bottom: 1px solid #e8e8e8;
    }

    img {
      position: relative;
      width: 40px;
      height: 40px;
      margin-right: 16px;
    }
  `}
`;

export const TopicText = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    width: 100%;

    p {
      display: inline-block;

      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      color: ${theme.colors.colorGray500};

      + p {
        margin-top: 4px;
      }

      span {
        color: ${theme.colors.colorGray400};
      }

      a {
        color: ${theme.colors.blueEinstein};
        text-decoration: underline;
      }
    }

    .more-space {
      margin-top: 8px;
    }
  `}
`;
